//if (theme.settings.cartType === 'drawer') {
  document.querySelectorAll('.addtocart-btn').forEach(function(atc) {
    atc.addEventListener('click', function() {
    this.classList.add('btn--loading');
    
    // const subscriptionInput = this.closest('.grid-product__content').querySelector('.product-grid-complimentary_product:not(.compatible-filter) input:checked');
    let formData;
  
    let selling_plan_id = atc.dataset.compatibleProduct;
    let compatible_variant_id = (this.closest('.grid-product__content').querySelector('input[name="compatibleVariantId"]') != null) ? this.closest('.grid-product__content').querySelector('input[name="compatibleVariantId"]').value : '';
  
    let first_item = {
      'id': atc.dataset.productVariant,
      'quantity': 1
    }
  
    let items = []
  
    if (compatible_variant_id == '') {
      if (selling_plan_id !== '') first_item['selling_plan'] = selling_plan_id;
      items = [first_item]
    } else {
      let compatible_item = {
        'id': compatible_variant_id,
        'quantity': 1
      }
      if (selling_plan_id !== '') compatible_item['selling_plan'] = selling_plan_id;
      items = [compatible_item, first_item]
    }
  
    console.log("payload: ", items)
    
    formData = {
      'items': items
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(function(data) {
      if (data.status === 422) {
  
      } else {
          atc.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: data,
                addToCartBtn: atc
              },
              bubbles: true
            }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      this.classList.remove('btn--loading');
      console.log(formData);
    });
    });
  });
  //}
  
  document.querySelectorAll('.product-grid-complimentary_product input').forEach(function(product) {
    product.addEventListener('click', function() {
      product.closest('.grid-product__content').querySelector('.addtocart-btn').setAttribute('data-compatible-product', this.value);
    });
  });

//swym add to cart 
function renderCartDrawer(swat) {
  let event = 'sw:addedtocart';
  swat.evtLayer.addEventListener(event, function(eventData) {
    console.log("A product was added to cart", eventData);
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true
    }));
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderCartDrawer);
